const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/about"],
    exact: true,
    component: "About",
  },
  {
    path: ["/services"],
    exact: true,
    component: "Services",
  },
  {
    path: ["/services/:slug"],
    exact: true,
    component: "ServiceDetails",
  },
  {
    path: ["/portfolio"],
    exact: true,
    component: "Portfolio",
  },
  {
    path: ["/portfolio/:slug"],
    exact: true,
    component: "PortfolioDetails",
  },
  {
    path: ["/contact-us"],
    exact: true,
    component: "Contact",
  },
];

export default routes;
